import $ from 'jquery'

/**
 * Checks if an element is in the viewport
 * @param $el {jQuery|HTMLElement}
 * @param fully {boolean} element must be fully visible
 * @returns {boolean}
 */
export function isInViewport ($el, fully = true) {
  const $element = $el instanceof jQuery ? $el : $($el)
  let elementTop = $element.offset().top,
    elementBottom = elementTop + $element.outerHeight(),
    viewportTop = $(window).scrollTop(),
    viewportBottom = viewportTop + $(window).height()

  if (fully) {
    return elementTop >= viewportTop && elementBottom <= viewportBottom
  }

  return elementTop < viewportBottom || elementBottom > viewportTop
}

/**
 *
 * @param func
 * @param wait
 * @param immediate
 * @returns {(function(): void)|*}
 */
export function debounce (func, wait, immediate) {
  let timeout
  return function () {
    let context = this,
      args = arguments
    let later = function () {
      timeout = null
      if (!immediate) func.apply(context, args)
    }
    let callNow = immediate && !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
    if (callNow) func.apply(context, args)
  }
}

export function getCurrencyFormatInParts (locale, currency, value) {
  const localeRegion = locale.split('-')[1] // ex. "de-AT" -> "AT"

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    useGrouping: 'auto',
  })
    .formatToParts(value)
    .map((part) => {
      if (part.type === 'group') {
        switch (localeRegion) {
          case 'CH':
            part.value = '\''
            break
          case 'AT':
            part.value = ' '
            break
        }
      }
      return part
    })
}

export function getCurrencyFormatNumbersOnly (locale, currency, value) {
  return getCurrencyFormatInParts(locale, currency, value)
    .map((part) => (part.type !== 'currency' ? part.value : ''))
    .join('')
    .trim()
}

export function getCurrencyFormatCurrencyOnly (locale, currency, value) {
  return getCurrencyFormatInParts(locale, currency, value)
    .map((part) => (part.type === 'currency' ? part.value : ''))
    .join('')
}

export function getCurrencyFormat (locale, currency, value) {
  return getCurrencyFormatInParts(locale, currency, value)
    .map((part) => part.value)
    .join('')
}
